import { Link } from '@/components/link';

export type DrawerNavLinksProps = {
  links: readonly { title: string; url: string }[];
  navTitle?: string;
  isPrimary?: boolean;
};

const DrawerNavLinks = ({ links, navTitle, isPrimary = true }: DrawerNavLinksProps) => {
  return (
    <nav className="flex flex-col gap-4">
      {navTitle && <p className="text-lg">{navTitle}</p>}
      <ul className="flex flex-col gap-4">
        {links.map((link) => (
          <li key={link.title}>
            <Link
              href={link.url}
              className="font-bold text-2xl"
              tracking={{
                event: 'navigation_click',
                navigation_type: 'main_nav',
                click_text: link.title,
                nav_level: isPrimary ? '1' : '2',
              }}
            >
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default DrawerNavLinks;
